import script from "./SuccessMark.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessMark.vue?vue&type=script&setup=true&lang=js"

import "./SuccessMark.vue?vue&type=style&index=0&id=d0320a68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0320a68"]])

export default __exports__